import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import Navigation from 'components/navigation'
import OpenGraph from 'common/open-graph'
import { useLearningPlan } from 'querys/course'
import { prefetchSubscriptionPlans } from 'querys/subscriptions'
import InternalError from 'errors/internal-error'
import OnDeploy from 'common/on-deploy'
import { prefetchPendingProjects } from 'querys/projects-plan'
import LearningPlanLayout from 'components/learning-plan/layout'
import LearningPlanProjects from 'components/learning-plan/learning-plan-projects'

function ProjectsPath() {
  const { data, error } = useLearningPlan()

  if (error?.message === 'User Unauthorized') return null
  if (error?.message === 'Internal Error') return <InternalError />

  return (
    <>
      <OpenGraph
        title="Aprende a programar desde 0"
        url="https://leonidasesteban.com/aprender"
        keyword="Cursos de Desarrolo Web, Cursos de React, leonidasesteban.com, La mejor carrera de Frontend, Leonidas Esteban, Rutas de aprendizaje de programacion, Master programacion web"
        description="El plan de estudio paso a paso y desde cero para aprender a programar"
        image="/images/open-graph/plan-de-estudios-leonidas-esteban.jpg"
      />
      <Navigation background="var(--sky)" noCountdown />
      {data ? (
        <LearningPlanLayout>
          <LearningPlanProjects />
        </LearningPlanLayout>
      ) : (
        <>
          {error?.message === 'Deploy' ? <OnDeploy /> : null}
        </>
      )}
    </>
  )
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchSubscriptionPlans({ queryClient, product: 'ALL' })
  await prefetchPendingProjects({ queryClient })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 3600,
  }
}

export default ProjectsPath
